<ejs-dialog target=".dialogs" class="steps-dialog" [visible]='visible' [animationSettings]='dialogService.getAnimationSettings()' [resizeHandles]='dialogService.getResizeHandleDirection()' [position]='dialogService.getPosition()' [isModal]="true" [allowDragging]="false" [width]="'60%'" [height]="'60vh'" [zIndex]="999" [showCloseIcon]="false" (close)="close()" [cssClass]="'chat-create-group-dialog'" [header]='header' [content]='content'>
  <ng-template #header class="p-1">
    <app-step-header [steps]="stepTitles" [activeStep]="activeStep" (activeStepChange)="handleStepChange($event)"></app-step-header>
  </ng-template>
  <ng-template #content>
    <div class="d-flex h-100">
      <!-- Left Column -->
      <div class="col-md-4 col-12 d-none d-md-flex flex-column left-container h-100 p-3">
        <div class="text-center mb-4 pt-m">
          <app-headline [title]="(editingChat() ? 'CHATGROUPEDIT' : 'CHATGROUPCREATE') | translate" [type]="'h5'"></app-headline>
        </div>
        <app-step-content [steps]="stepTitles" [activeStep]="activeStep" (activeStepChange)="handleStepChange($event)"></app-step-content>
        <div class="save-button-container text-center mt-3 d-none d-md-block">
          <app-form-button [text]="'SAVE' | translate" [disabled]="chatForm.invalid || !hasSelectedParticipants" (click)="save()" [cssClass]="'e-primary w-100'"></app-form-button>
        </div>
      </div>

      <!-- Right Column -->
      <div class="col-md-8 col-12 d-flex flex-column flex-grow-1 right-container h-100 overflow-y-auto p-3">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <div class="d-flex align-items-center">
            <app-headline [title]="steps[activeStep].title" [type]="'h5'"></app-headline>
            @if (steps[activeStep]?.optional) {
              <app-headline [title]="'('+('OPTIONALLABEL' | translate) +')'" [type]="'h6'" [class]="'text-success ms-1'"></app-headline>
            }
            <div class="ms-2">
                @if (steps[activeStep]?.help; as help) {
                  <app-tooltip [icon]="'help'" [iconClass]="'fs-5 p-1'" [text]="help" [width]="'300px'" [height]="'100px'" [cssClass]="'helpTooltip p-2'" [opensOn]="'Click'"></app-tooltip>
                }
            </div>
          </div>
          <app-form-button [style]="'btn'" (click)="close()" [cssClass]="'btn-close'"></app-form-button>
        </div>

        <div class="custom-scrollbar overflow-y-auto">
          <form class="p-1 d-flex flex-column h-100">
            @switch(steps[activeStep]?.id) {
              @case ('content') {
                <app-form-label [label]="'CHATCONVERSATIONNAMELABEL' | translate" [maxChars]="60" [currentChars]="chatForm.controls['title'].value?.length"></app-form-label>
                <app-form-input [placeholder]="('CHATCONVERSATIONTITLEPLACEHOLDER' | translate)" [label]="('CHATCONVERSATIONTITLEPLACEHOLDER' | translate)" [errorText]="('CHATCONVERSATIONTITLEREQUIRED' | translate)" [fCN]="'title'" [fG]="chatForm" [maxChars]="60"></app-form-input>
              }
              @case ('groupimage') {
                <app-dialog-documents-upload [view]="'component'" [(files)]="mediaFiles" [multiple]="false" [type]="'image'"></app-dialog-documents-upload>
              }
              @case ('participants') {
                <app-form-user-group-mail 
                  [allowEmails]="false" 
                  [allowPush]="false" 
                  [allowAdmins]="true" 
                  [can]="'chat'"
                  [(adminUserIDs)]="participantsAdminUserIDs" 
                  [(user)]="participantsUserIDs" 
                  [(groups)]="participantsGroupIDs" 
                  (userModelChange)="participantsUserModels = $event" 
                  (groupModelChange)="participantsGroupModels = $event" 
                  [hasError]="isUserGroupSelectionError"
                  >
                </app-form-user-group-mail>
              }
            }
          </form>
        </div>

        <div class="d-flex justify-content-between mt-3 d-none d-md-flex">
          @if (activeStep > 0) {
            <app-form-button [text]="'PREV' | translate" (click)="activeStep = activeStep - 1" [cssClass]="'e-outline w-20'"></app-form-button>
          }
          @if (activeStep < steps.length - 1) {
            <app-form-button [text]="'NEXT' | translate" (click)="handleStepChange()" [cssClass]="'e-secondary ms-auto w-20'"></app-form-button>
          }
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #footerTemplate>
    <div class="d-md-none d-flex gap-2 p-2">
      <div class="flex-shrink-0">
        @if (activeStep > 0) {
          <app-form-button [text]="'PREV' | translate" (click)="activeStep = activeStep - 1" [cssClass]="'e-outline w-100 mx-1'"></app-form-button>
        } @else{
          <!-- Dummy button to keep the space for the flex container -->
          <app-form-button [text]="'PREV' | translate" [cssClass]="'e-outline invisible w-100 mx-1'"></app-form-button>
        }
      </div>
      <div class="flex-grow-1 d-flex justify-content-center">
        <app-form-button [text]="'SAVE' | translate" [disabled]="chatForm.invalid || !hasSelectedParticipants" (click)="save()" [cssClass]="'e-primary w-90'"></app-form-button>
      </div>
      <div class="flex-shrink-0">
        @if (activeStep < steps.length - 1) {
          <app-form-button [text]="'NEXT' | translate" (click)="handleStepChange()" [cssClass]="'e-secondary w-100 mx-1'"></app-form-button>
        }

        <!-- Dummy button to keep the space for the flex container -->
        @if (activeStep === steps.length - 1) {
          <app-form-button [text]="'NEXT' | translate" (click)="handleStepChange()" [cssClass]="'e-secondary invisible w-100 mx-1'"></app-form-button>
        }
      </div>
    </div>
  </ng-template>
</ejs-dialog>
